import { HTTP } from "@/api";

import session from "./session";
import subscription from "./subscription";
import social from "./social";
import prematch from "./prematch";
import ticker from "./ticker";
import ads from "./ads";
import matchAction from "./matchAction";
import prematchAction from "./prematchAction";
import favorites from "./favorites";

const categories = { prematch, ticker };

export default {
  ...session,
  ...subscription,
  ...social,
  ...ads,
  ...matchAction,
  ...prematchAction,
  ...favorites,
};
